export const getBusinessAddressSelectorStyles = () => ({
  selectorOption: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  deleteAddressBtn: {
    color: '#0078d4',
    marginLeft: 16,
  },
  addressSelectorRadioGroup: {
    '& label': {
      padding: 0,
    },
    '& .ms-ChoiceField-wrapper': {
      width: '100%',
    },
    '& .ms-ChoiceFieldLabel': {
      fontWeight: 400,
    },
  },
  deleteDisabled: {
    color: '#A19F9D',
  },
  emptyBusinessAIVAddressWarning: {
    marginTop: 15,
  },
});
